import { ErrorList } from "../alerts";

type Props = {
  error: any;
};

export default function ErrorPanel({ error }: Props) {
  return <ErrorList error={error} />;
}
